import React from "react";
import "./banner.css";
import { withRouter} from "react-router-dom";
import { directDeepLink, SOURCE_HOME } from "./util";
import studentSpinAnimation from "./assets/doubt-buddy-.json";
import Lottie from "react-lottie";

// temp
function Banner(props) {
	let url = new URL(window.location.href);
	const token = url.searchParams.get("token");

	let deepLink = {
		screen: 'UTIL_WEBVIEW',
		paramOne: `https://campaigns-preprod.classplus.co/student/?token=${token}`,
		paramTwo: '',
		paramTracking: 'StudentSideBannerClickTracking',
		paramThree: '',
		paramSource: '',
	};
	const bannerAnimation = {
		loop: true,
		autoplay: true,
		animationData: studentSpinAnimation,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};
	function bannerClicked(){
		directDeepLink(deepLink, SOURCE_HOME);
	}

  return (
    <div className="layoutBanner">
      <div className="Banner" onClick={bannerClicked}>
		  <Lottie options={bannerAnimation}  />
		  {/*<img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/banner-gyan-live.png" alt="banner"/>*/}
      </div>
    </div>
  );
}
export default withRouter(Banner);
